// extracted by mini-css-extract-plugin
export var details = "_fk-0";
export var inspectorPopover = "_fk-1";